<template>
<div class="chapter">
<div class="inner_page">
<p class="chap1">CONTENTS</p>
<p class="toc"><a href="#/foreword">Foreword, by Scott Hanzelka</a></p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/pro">Prologue</a></p>
<p class="toc1"><a href="#/chapter01">1. Texas: No Leisure on the New Frontier</a></p>
<p class="toc"><a href="#/chapter02">2. The Civil War, Reconstruction and Baseball: Division and Diversion</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Professional Baseball: Faith and Failure in Texas</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Sherman, Denison and the Fenceless Frontier</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. 1895: The Texas League’s First Foray into a Second-Tier City</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. 1896: A Rivalry Cut Short</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Paris: Stepping up to Save the Circuit</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. 1897: The Increasing Railroad Influence</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. 1902: The Interurban and a Team for the Ages</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. 1903: Competitive Balance</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. 1904: Small Cities Sandwich the League</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. 1905: A Shorter Jump</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. 1906: New Cities, New Legends</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. 1907: The Small Market’s Last Stand</span></p>
<p class="toc1"><span href="#/after" title="Link target outside of Sample">Afterword</span></p>
<p class="toc"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6cf648ca